@let isUserAuthorized = isUserAuthorized$ | async;
@let hideLoginRedirect = hideLoginRedirect$ | async;
@let isSettingsLoading = isSettingsLoading$ | async;

<div class="toolbar">

    <div class="toolbar-box" [class.not-authorized]="!isUserAuthorized">

        <logo class="toolbar-logo">
        </logo>

        @if (!isUserAuthorized && !hideLoginRedirect) {
        <div class="toolbar-auth-wrap">

            <rpc-button [link]="RpcRoute.Login" [text]="'TOOLBAR.TITLES.LOGIN'" [color]="'accent'">
            </rpc-button>

        </div>
        }

        @if (isUserAuthorized) {

        <div class="rpc-divider rpc-divider--vertical divider-first">
        </div>

        @if (!isSettingsLoading) {
        @let unviewedListingsCount = unviewedListingsCount$ | async;
        @let canSearchForListings = canSearchForListings$ | async;
        @let isFindHomeActive = isFindHomeActive$ | async;

        <div class="toolbar-menu">

            @if (canSearchForListings) {

            <rpc-button class="toolbar-menu-item" [text]="'TOOLBAR.TITLES.FIND_HOME'" [actionClass]="'rpc-active'"
                [actionTrigger]="isFindHomeActive" (clicked)="onFindHomeClick(isFindHomeActive)">
            </rpc-button>

            <rpc-button class="toolbar-menu-item" [text]="'TOOLBAR.TITLES.SAVED_SEARCHES'"
                [disabled]="(savedSearchesInfo$ | async).length === 0" (clicked)="openSavedSearchesList()">
            </rpc-button>

            }

            <rpc-button class="toolbar-menu-item" [link]="portfolioRouterLink$ | async"
                [routerLinkActive]="'rpc-active'" [text]="'TOOLBAR.TITLES.MY_LISTINGS'"
                [badge]="{ badgeCountAlert: unviewedListingsCount}" [title]="unviewedListingsCount > 0 
                            ? ('TOOLBAR.TOOLTIPS.NEW_LISTINGS_IN_PORTFOLIO'  | translate : {count: unviewedListingsCount}) 
                            : 'TOOLBAR.TITLES.MY_LISTINGS'">
            </rpc-button>

            @let unviewedAppointmentsCount = unviewedAppointmentsCount$ | async;
            @let appointmentsCount = appointmentsCount$ | async;

            <rpc-button class="toolbar-menu-item" [link]="RpcRoute.Appointments" [routerLinkActive]="'rpc-active'"
                [text]="'TOOLBAR.TITLES.MY_APPOINTMENTS'"
                [badge]="{badgeCount: appointmentsCount, badgeCountAlert: unviewedAppointmentsCount}" [title]="unviewedAppointmentsCount > 0 
                        ? ('TOOLBAR.TOOLTIPS.NEW_UPCOMING_APPOINTMENTS_IN_PORTFOLIO'  | translate : {count: (unviewedAppointmentsCount)})
                        : appointmentsCount > 0 
                            ? ('TOOLBAR.TOOLTIPS.APPOINTMENTS_IN_PORTFOLIO'  | translate : {count: appointmentsCount})
                            : 'TOOLBAR.TITLES.MY_APPOINTMENTS'">
            </rpc-button>

        </div>
        }

        <div class="toolbar-right-section">

            <rpc-button class="toolbar-knowledge" [actionClass]="'rpc-active'"
                [actionTrigger]="isKnowledgeBaseOpened$ | async" [iconName]="'question'"
                [title]="'TOOLBAR.TITLES.KNOWLEDGE_BASE'" (clicked)="onKnowledgeBaseClicked()">
            </rpc-button>

            @let agents = agents$ | async;

            @if (agents.length > 0) {

            <rpc-button class="toolbar-agent-btn" [appearanceType]="'stroke'"
                [text]="'TOOLBAR.TITLES.CONTACT_AGENT' | translate" [rpcDropdown]="agentsList"
                [dropdownCustomClass]="'toolbar-agent-modal'">

                <portfolio-agents-list class="toolbar-agent-info" [agents]="agents">
                </portfolio-agents-list>

                <ng-container rpcButtonPrefix>

                    @if (agents.length === 1) {

                    <rpc-avatar class="toolbar-agent-btn-avatar" [userFullName]="agents[0].fullName"
                        [profileImageUrl]="agents[0].profilePictureUrl">
                    </rpc-avatar>

                    } @else {

                    <avatars-icon class="toolbar-agent-btn-avatar" [front]="getAgentAvatarInfo(agents[0])"
                        [back]="getAgentAvatarInfo(agents[1])">
                    </avatars-icon>

                    }

                </ng-container>

            </rpc-button>

            <ng-template #agentsList class="toolbar-agent-modal">

                <portfolio-agents-list class="toolbar-agent-info" [agents]="agents">
                </portfolio-agents-list>

            </ng-template>

            }

            @let unviewedNotificationTotalCount = unviewedNotificationTotalCount$ | async;

            <div class="toolbar-notification">

                <rpc-button class="toolbar-notification-item d-view" [iconName]="'bell'"
                    [badge]="{badgeCountAlert: unviewedNotificationTotalCount, badgeCountAlertLimit: badgeCountAlertLimit, animationConfig: badgeAlertAnimationConfig}"
                    #notificationsDropdown="rpcDropdownApi" [rpcDropdown]="notificationBell"
                    [dropdownCustomClass]="'rpc-notifications-dropdown'" (closed)="onNotificationBellClosed()">
                </rpc-button>

                <ng-template #notificationBell class="rpc-notifications-dropdown">

                    <notifications (notificationSourceNavigated)="onNotificationSourceNavigated($event)"
                        (closed)="notificationsDropdown.close()">
                    </notifications>

                </ng-template>

            </div>

            <div class="rpc-divider rpc-divider--vertical divider-second">
            </div>

            <div class="toolbar-user">

                @let customerFullName = customerFullName$ | async;
                @let customerProfileImage = customerProfileImage$ | async;

                @if (customerFullName != null) {

                <div class="toolbar-user-link" [title]="customerFullName" [rpcDropdown]="userMenu"
                    #userMenuDropdown="rpcDropdownApi">

                    <rpc-avatar class="username-avatar" [userFullName]="customerFullName"
                        [profileImageUrl]="customerProfileImage">
                    </rpc-avatar>

                </div>

                <ng-template #userMenu>

                    <div class="rpc-dropdown rpc-dropdown--pure">

                        <rpc-button class="rpc-dropdown-btn" [text]="'TOOLBAR.TITLES.PROFILE'" [iconName]="'user'"
                            (clicked)="onMyProfileClicked(); userMenuDropdown.close()">
                        </rpc-button>

                        @if (canSeeAdditionalProfiles$ | async) {

                        @let canAddAdditionalProfile = canAddAdditionalProfile$ | async;

                        <rpc-button class="rpc-dropdown-btn" [text]="'TOOLBAR.TITLES.INVITE_USER'"
                            [iconName]="'invite-user'" [disabled]="!canAddAdditionalProfile"
                            (clicked)="onInviteUser(); userMenuDropdown.close()">
                        </rpc-button>

                        }

                        <rpc-button class="rpc-dropdown-btn" [text]="'TOOLBAR.TITLES.SETTINGS'" [iconName]="'cog'"
                            (clicked)="onSettingsClicked(); userMenuDropdown.close()">
                        </rpc-button>

                        @if (hasMultipleCollaborationSpaces$ | async) {
                        <rpc-button class="rpc-dropdown-btn" [text]="'TOOLBAR.TITLES.CHANGE_AGENT'"
                            [iconName]="'agent-switch'" [routerLinkActive]="'active'"
                            (clicked)="onChangeAgentClicked(); userMenuDropdown.close()">
                        </rpc-button>
                        }

                        <rpc-button class="rpc-dropdown-btn" [text]="'TOOLBAR.TITLES.LOGOUT'"
                            [iconName]="'sign-out-square-fill'" (clicked)="onLogoutClicked(); userMenuDropdown.close()">
                        </rpc-button>

                    </div>

                </ng-template>

                }

            </div>

        </div>

        }

    </div>

</div>